/**
 * PATH: apps/ai/src/services/streaming/auth.ts
 * PURPOSE: Auth helpers for AI streaming service
 */

import { getAuthCookie } from '@quotech/auth';
import {
  buildOrganisationHeader,
  getActiveOrganisationId,
} from '../../../organisation';

export function getAccessToken(): string | null {
  const cookieToken = getAuthCookie();
  if (cookieToken) return cookieToken;
  const legacyKeys = ['IdToken', 'accessToken', 'accessTokennew', 'access_token', 'token'];
  for (const key of legacyKeys) {
    const value = localStorage.getItem(key);
    if (value) return value;
  }
  return null;
}

export function getTenantId(): string {
  return getActiveOrganisationId();
}

export { buildOrganisationHeader };
